import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import LoadingPanel from "../components/sys-toolbox/LoadingPanel";

import { Home } from "../pages/Home/Home";
import { NoMatch } from "../utils/common";
import { Events } from "../pages/Event/Events";
import { EventDetail } from "../pages/Event/EventDetail";
import { Templates } from "../pages/MailTemplate/Templates";
import { CompanyCalendar } from "../pages/Calendar/CompanyCalendar";
import { ParticipantInfo } from "../pages/Participant/ParticipantInfo";
import { CompanySchedulerIntra } from "../containers/CompanyCalendar/CompanySchedulerIntra";

const App = () => {
  return (
    <Layout>
      <Suspense fallback={LoadingPanel}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

/**
 * @type {import("react-router-dom").RouteObject[]}
 */
export const protectedRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <Home /> },
      { path: "404", element: <NoMatch /> },
      { path: "*", element: <Navigate to="404" /> },
      { path: "/events", element: <Events to="404" /> },
      { path: "/event/:id", element: <EventDetail to="404" /> },
      { path: "/template", element: <Templates to="404" /> },
      { path: "/calendar", element: <CompanyCalendar to="404" /> },
      { path: "/participant/:id", element: <ParticipantInfo /> },
      {
        path: "/company-calendar",
        element: <CompanySchedulerIntra />,
      },
    ],
  },
];
